import styled from 'styled-components';
import { Input } from 'antd';
import { Plus } from 'styled-icons/boxicons-regular';

export const ExtraItensInputContainer = styled.div`
  width: 100%;
  min-width: 9.25rem;

  &:not(:last-child) {
    margin-right: 1rem;
  }

  &.smaller-input {
    min-width: unset;
    & > input {
      @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
        max-width: 6.5rem;
      }
    }
  }

  & > .title {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-weight: bold;
    font-size: 0.875rem;

    & > .measure_a {
      color: ${({ theme }) => theme.colors.green5};
      font-weight: bold;
    }
    & > .measure_b {
      color: ${({ theme }) => theme.colors.blue5};
      font-weight: bold;
    }
    & > .measure_c {
      color: ${({ theme }) => theme.colors.red4};
      font-weight: bold;
    }
  }
`;

export const EIInput = styled(Input)`
  @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    max-width: 6.5rem;
  }
`;

export const ExtraItensContentBlock = styled.div`
  &.optional-msg-block {
    margin: 0.5rem 0;
  }

  & > span.optional-msg {
    font-size: 0.875rem;

    & > button {
      padding: 0 0.25rem;
      font-weight: 700;
    }
  }

  & > .title {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-weight: bold;
    font-size: 1.125rem;
  }

  & > .subtitle {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-size: 0.875rem;
  }

  &.bottom-bordered {
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray6};
    margin-bottom: 1.25rem;
  }
`;

export const ExtraItemContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  transition: opacity 1s;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 0.5rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    flex-wrap: nowrap;
    padding: 0.5rem 0 0 0;
  }

  &.odd {
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      background-color: ${({ theme }) => theme.colors.white2};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
      background-color: unset;
    }
  }

  &.remove-element {
    opacity: 0;
  }

  transition: opacity 0.5s;
  animation: newItem 1s ease;
  @keyframes newItem {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0.75;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const ExtraItensBlock = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.25rem;
  padding: 0.75rem 0.75rem;
  margin: 0.75rem 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 1.5rem 1.5rem;
  }

  & > .block-title {
    color: ${({ theme }) => theme.colors.black};
    font-weight: bold;
    font-size: 1.125rem;
  }
`;

export const ExtraItemContentBlock = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  margin-bottom: 1rem;

  &:first-child > div {
    margin: 0 0 1rem 0;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      margin: 0 1rem 0 0;
    }

    &:last-child {
      margin: 0;
    }
  }

  &:first-child {
    flex-wrap: wrap;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    &:first-child {
      flex-wrap: nowrap;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    width: unset;
    &:not(:last-child) {
      margin-right: 1rem;
    }
  }
`;
export const AddExtraItemIcon = styled(Plus)`
  width: 1.25rem;
  margin-right: 0.5rem;
`;
export const AddExtraItemContainer = styled.div`
  width: 95%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.25rem;
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem;
  margin: 0 2rem 1rem;
`;

export const ButtonContainer = styled.div`
  width: 95%;
  border-radius: 0.25rem;
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem;
  margin: 0 2rem 1rem;
  gap: 1rem;

  & > button {
    width: 20rem;
  }
`;

export const NewExtraItensContentBlock = styled.div`
  &.optional-msg-block {
    margin: 0.5rem 0;
  }

  & > span.optional-msg {
    font-size: 0.875rem;

    & > button {
      padding: 0 0.25rem;
      font-weight: 700;
    }
  }

  & > .title {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-weight: bold;
    font-size: 1.125rem;
  }

  & > .subtitle {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-size: 0.875rem;
  }

  &.bottom-bordered {
    margin-bottom: 1.25rem;
  }
`;
